import React, { useEffect } from "react";
import { historyLists } from "../../data/history";
import * as S from "./styled";
import SubVisualHistory from "../../assets/subVisual/subVisualHistory.webp";
import SubVisual from "../../components/SubVisual";
import Aos from "aos";
import { Helmet } from "react-helmet-async";

const History = () => {
  useEffect(() => {
    if (typeof window === "undefined") return;

    const isReactSnap = navigator.userAgent === "ReactSnap";

    if (!isReactSnap) {
      Aos.init();
      window.scrollTo(0, 0);
    } else {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, []);
  return (
    <>
      <Helmet>
        <title>IPDIA 국제실용댄스지도자협회</title>

        <meta
          name="description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />

        <meta
          name="keywords"
          content="IPDIA, 아이피디아, 국제실용댄스지도자협회, 국제실용댄스, 셔플댄스, 댄스협회, 댄스자격증, 실용무용, 댄스강사자격증"
        />

        <meta property="og:title" content="넵튠 댄스 스튜디오" />
        <meta
          property="og:description"
          content="전문 댄스강사 양성 및 실용무용 교육과 네트워크를 선도하는 국제실용댄스지도자협회입니다."
        />
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://ipdiakorea.com" />
        <meta
          property="og:image"
          content="https://ipdiakorea.com/og-image.png"
        />
      </Helmet>
      <S.HistoryContainer>
        <SubVisual
          src={SubVisualHistory}
          title="협회 연혁"
          subTitle="협회 소개"
        />
        <S.HistoryWrapper>
          <div className="small-inner">
            <S.HistoryWrap>
              <ul>
                <li>
                  {historyLists.map((item, index) => (
                    <div
                      className="history-wrap"
                      data-aos="fade-up"
                      data-aos-duration={600}
                      data-aos-delay={(index + 1) * 200}
                      data-aos-easing="linear"
                    >
                      <h6>{item.title}</h6>
                      <div>
                        <S.HistoryCircle listsLength={item.lists.length} />
                      </div>
                      <ul>
                        {item.lists.length > 0 &&
                          item.lists.map((list) => (
                            <li>
                              <span>{list.date}</span>
                              <p>{list.text}</p>
                            </li>
                          ))}
                      </ul>
                    </div>
                  ))}
                </li>
              </ul>
            </S.HistoryWrap>
          </div>
        </S.HistoryWrapper>
      </S.HistoryContainer>
    </>
  );
};

export default History;
